import React, { useState } from 'react';
import './OrderModal.css';

const EMAIL_ADDRESS = 'watchly@inceptech.ru';

function OrderModal({ isOpen, onClose }) {
  const [step, setStep] = useState('choice'); // 'choice' | 'email'

  if (!isOpen) return null;

  const handleAvito = () => {
    // Замените на реальную ссылку на вашу услугу на Авито
    window.location.href = 'https://www.avito.ru/sankt-peterburg/predlozheniya_uslug/kastomnye_chasy_na_zakaz_8189036442';
  };

  const handleEmailChoice = () => {
    setStep('email');
  };

  const handleEmail = () => {
    window.location.href = `mailto:${EMAIL_ADDRESS}`;
  };

  const handleClose = () => {
    setStep('choice');
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={handleClose}>✕</button>

        {step === 'choice' && (
          <div className="choice-step">
            <h2>Как вы хотите заказать?</h2>
            <div className="choice-buttons">
              <button onClick={handleEmailChoice} className="choice-btn email-btn">
                📧 Написать нам на почту
              </button>
              <button onClick={handleAvito} className="choice-btn avito-btn">
                📦 Услуга на Авито
              </button>
            </div>
          </div>
        )}

        {step === 'email' && (
          <div className="email-step">
            <h2>Написать нам на почту</h2>
            <p className="email-hint">
              Напишите нам на почту — мы свяжемся с вами в ближайшее время.
            </p>
            <a href={`mailto:${EMAIL_ADDRESS}`} className="email-address">
              {EMAIL_ADDRESS}
            </a>
            <div className="email-actions">
              <button type="button" onClick={handleEmail} className="write-btn">
                ✉️ Написать
              </button>
              <button type="button" onClick={handleClose} className="close-btn">
                Закрыть
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default OrderModal;
